<template>
    <div id="CustomerEstimateList">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
            <template v-if="cantAccessPage === true">
                    <div class="admin-page-content customer-estimate-list">
                        <div class="btn-groups text-right special-btns">
                            <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
                                <i class="fp-export"></i> Export
                            </a>
                            <template v-if="canAddWorkOrderEstimate == true">
                                <router-link class="btn btn-primary" v-bind:to="{name: 'CustomerEstimateCreate'}" > <i class="fp-add"> </i> Add</router-link>
                            </template>
                        </div>
                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <data-table-filter-config :moduleName="'listWorkOrderEstimate'" ref="filterCustEstimate" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="bg-white data-table">
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange" :moduleName="'listWorkOrderEstimate'" :position="'top'">
                                  </custom-pagination>
                                <vue-good-table
                                  ref="listEstimateWorkOrderTable"
                                  mode="remote"
                                  title="Estimate"
                                  @on-page-change="onPageChange"
                                  @on-selected-rows-change="selectionChanged"
                                  @on-column-filter="onColumnFilter"
                                  @on-per-page-change="onPerPageChange"
                                  @on-sort-change="onSortChange"
                                  :totalRows="totalRecords"
                                  :columns="userColumns"
                                  @on-select-all="onSelectAll"
                                  :rows="rows"
                                  :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          dropdownAllowAll: false,
                                      }"
                                  :select-options="{
                                      enabled: true,
                                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                      selectionInfoClass: 'custom-class',
                                      selectionText: 'rows selected',
                                      clearSelectionText: 'clear',
                                      }"
                                  :search-options="{
                                      enabled: false,
                                      }">

                                  <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                    <div :key="key">
                                      <div v-if="props.column.field == 'action'" class='text-center'>
                                          <template v-if="canEditEstimateWorkOrder == true && props.row.status.toLowerCase() != 'approved'">
                                              <router-link title="Edit Customer Estimate" class="fp-edit" v-bind:to="{name: 'CustomerEstimateEdit',params:{id:props.row.id}}"></router-link>
                                          </template>
                                      </div>
                                      <div v-else-if="props.column.field == 'work_order_estimate_no' && canViewEstimateWorkOrder === true" class='text-center'>
                                          <router-link title="View Work Order Estimate" class="color-blue"  v-bind:to="{name: 'CustomerEstimateView',params:{id:props.row.id}}">{{props.row.work_order_estimate_no}}</router-link>
                                      </div>
                                      <div v-else-if="props.column.field == 'work_order_no' && canViewWorkOrder === true" class='text-center'>
                                          <template v-if="props.row.work_order_no != '-'">
                                              <router-link title="View Work Order" class="color-blue"  v-bind:to="{name: 'WorkOrderView',params:{id:props.row.work_order_id},query:{from:'cust_estimate', fromUrl:fromUrl}}">{{props.row.work_order_no}}</router-link>
                                          </template>
                                          <template v-else>
                                              {{props.row.work_order_no}}
                                          </template>
                                      </div>
                                      <div v-else-if="props.column.field == 'customer_unit'">
                                        <span v-fp-html="props.formattedRow[props.column.field]"></span>
                                      </div>
                                      <div v-else>
                                        {{props.formattedRow[props.column.field]}}
                                      </div>
                                    </div>
                                  </template>
                                  <div slot="selected-row-actions">
                                      <template v-if="canApproveRejectEstimate == true">
                                          <button id="approveRejectBtn" v-on:click.prevent="approveRejectEstimate" class="btn btn-primary">Approve / Reject</button>
                                      </template>
                                      <template v-if="canCreateWorkOrder == true">
                                          <button id="createWorkOrderBtn" v-on:click.prevent="createWorkOrder" class="btn btn-primary">Create Work Order</button>
                                      </template>
                                      <template v-if="canSendEstimateWorkOrder == true">
                                          <button id="sendWorkOrderEstimateBtn" v-on:click.prevent="sendWorkOrderEstimate" class="btn btn-primary">Send Mail</button>
                                      </template>
                                      <template v-if="canDeleteEstimateWorkOrder == true">
                                          <button id="deleteWorkOrderEstimateBtn" v-on:click.prevent="workOrderEstimateDelete" class="btn btn-danger">Delete</button>
                                      </template>
                                  </div>
                                </vue-good-table>
                                <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                            <div class="modal fade approve-reject-modal" id="approve-reject-modal" ref="approveRejectModal" data-backdrop="static" data-keyboard="false" aria-labelledby="approveRejectModal" aria-hidden="true">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title">Please Enter Reason</h5>
                                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                                        </div>
                                        <div class="modal-body">
                                            <div class="form-row">
                                                <div class="col form-group">
                                                    <label class="control-label require">Reason</label>
                                                    <textarea class='form-control' v-model="reason" ref="textarea" id="reason" rows="3"></textarea>
                                                    <div class="field-error">{{reason_error_msg}}</div>
                                                </div>
                                            </div>
                                            <div class="btn-groups">
                                                <button class="btn btn-primary" v-on:click="sendApproveOrRejectEstimate('approve')"> Approve </button>
                                                <button class="btn btn-tertiary" v-on:click="sendApproveOrRejectEstimate('reject')"> Reject </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
    </div>
</template>
<script>

import EventBus from "./event-bus";
import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "CustomerEstimateList",
        mixins:[commonMixins,dataTableMixins],
        props: {
            estimateWorkOrderVal: {
                type: String,
                required: false,
                default: undefined
            }
        },
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: '#Estimate',
                    field: 'work_order_estimate_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Estimate No", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" ,//only trigger on enter not on keyup
                    }
                },
                {
                    label: '#Work Order',
                    field: 'work_order_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Work Order No", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" ,//only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Unit',
                    field: 'unit_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit No.", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Customer Unit',
                    field: 'customer_unit',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer Unit.", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    html: true
                },
                {
                    label: 'Customer',
                    field: 'customer_id',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'User',
                    field: 'user_id',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "User", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Maintenance Type',
                    field: 'maintenance_type',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Maintenance Type", // placeholder for filter input
                        filterDropdownItems: ['Preventive Maintenance', 'Federal Maintenance','Other'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Open Date',
                    field: 'open_date',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Expiry Date',
                    field: 'expiry_date',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                // {
                //     label: 'Priority',
                //     field: 'priority',
                //     fpFieldType:"option",
                //     filterable: true,
                //     hidden:false,
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "Priority", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                // {
                //     label: 'Location',
                //     field: 'location',
                //     fpFieldType:"option",
                //     filterable: true,
                //     hidden:false,
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "Location", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                {
                    label: 'Status',
                    field: 'status',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Status", // placeholder for filter input
                        // filterDropdownItems: ['Open','In Progress' ,'Review', 'Closed'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            canDeleteEstimateWorkOrder: false,
            vehicle_id:"",
            loading:false,
            costCodeArr:[],
            canEditEstimateWorkOrder: false,
            canSendEstimateWorkOrder: false,
            canCreateWorkOrder: false,
            canViewEstimateWorkOrder: false,
            canAddWorkOrderEstimate: false,
            canViewWorkOrder:false,
            canApproveRejectEstimate:false,
            reason:"",
            reason_error_msg:"",
            action:'',
            pageKey:"_customer_estimate_list",
            fromUrl:"",
            batchProcess:0,
            batchNum:"",
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_customer_estimate') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'add_customer_estimate') {
                            self.canAddWorkOrderEstimate = true;
                            self.canEditEstimateWorkOrder = true;
                        }
                        if (permissions[i].name == 'delete_customer_estimate') {
                            self.canDeleteEstimateWorkOrder = true;
                        }
                        if (permissions[i].name == 'view_customer_estimate') {
                            self.canViewEstimateWorkOrder = true;
                        }
                        if (permissions[i].name == 'send_customer_estimate') {
                            self.canSendEstimateWorkOrder = true;
                        }
                        if (permissions[i].name == 'can_create_work_order_from_customer_estimate') {
                            self.canCreateWorkOrder = true;
                        }
                        if (permissions[i].name == 'view_work_order') {
                            self.canViewWorkOrder = true;
                        }
                        if (permissions[i].name == 'can_approve_reject_customer_estimate') {
                            self.canApproveRejectEstimate = true;
                        }

                    }
                }

            }

        },
        created: function() {

        },
        beforeDestroy(){
            this.$root.$off('work_order');
        },
        mounted: function() {
            var self = this;
            self.fromUrl = btoa(window.location.pathname);
            self.getPermissions();

        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listEstimateWorkOrderTable.unselectAllInternal();
            },

            selectionChanged(param) {
                var self = this;
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
            },


            loadList() {

                var self = this;

                var path = window.location.pathname;
                var segments = path.split("/");

                self.loading = true;

                var data = this.$refs['listEstimateWorkOrderTable'].selectedRows;
                var selectedId = [];
                if(self.action=='delete'){
                    for (var i = 0; i < data.length; i++) {
                        selectedId.push(self.$refs['listEstimateWorkOrderTable'].selectedRows[i].id)
                    }
                }
                if(self.action=='sendEstimate'){
                     selectedId = self.$refs['listEstimateWorkOrderTable'].selectedRows;
                }

                var use = [];
                for (var i = 0; i < data.length; i++) {
                      use.push(self.$refs['listEstimateWorkOrderTable'].selectedRows[i].id)
                }


                var fields = {
                    vehicle_id:segments[3],
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    listflag:self.action,
                    id:selectedId,
                    selectedRows:use,
                    all:self.serverParams.selectedAll,
                };

                self.firstLoad = 1;

                $.ajax({
                    url: process.env.ROOT_API + "/customer-estimate/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        console.log(data);
                        if (data.status == "success") {

                            if (self.action == "delete" ) {

                                self.action = "";
                                self.$refs.filterCustEstimate.clearSelectAll();
                                var msg = "";

                                msg = data.content.deleted+" records have been deleted";

                                if ( data.content.skipped == 1 ) {
                                    msg +=" and "+data.content.skipped+" record was approved so skipped that record";
                                } else if ( data.content.skipped > 1 ) {
                                    msg +=" and "+data.content.skipped+" records were approved so skipped that records";
                                }
                                msg +=".";

                                self.$swal('',msg,data.status);
                                setTimeout(function () {
                                    $("#deleteWorkOrderEstimateBtn").val("Delete");
                                }, 10000);
                                EventBus.$emit('clear-all-flags', false);
                                self.loadList();
                                return;
                            }else if(self.action== "sendEstimate"){
                                self.action = "";
                                self.$refs.filterCustEstimate.clearSelectAll();
                                if (data.code == '200') {
                                    var message = data.content;
                                    self.loadList();
                                    // self.$swal('','Mail Sent','success');
                                    self.$swal('',message,'success');

                                }else{
                                    self.$swal('','Oops please try again !!','error');
                                }

                                EventBus.$emit('clear-all-flags', false);

                            }else if ( self.action == "export" ||  self.action == "export_queue") {
                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {
                                    if ( self.action == "export" ) {
                                        self.excel = data.content.web;
                                        var save = document.createElement("a");
                                        save.href = self.excel;
                                        save.download = data.content.web;
                                        save.target = "_blank";

                                        document.body.appendChild(save);
                                        save.click();
                                        document.body.removeChild(save);

                                    } else {

                                        self.batchProcess = 1;
                                        self.batchNum = data.content;
                                    }
                                }
                                self.action = "list";
                                self.loadList();

                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.filteredFlag = false;
                                for (var i = 0; i < self.columns.length; i++) {
                                    if (self.columns[i].field == 'cost_code') {
                                        console.log(data.costCodes)
                                        self.columns[i].filterOptions.filterDropdownItems = data.costCodes;
                                    }
                                }

                                if (self.estimateWorkOrderVal == "customer") {

                                    EventBus.$emit("custWoCount", data.content.customerWoEstimateCnt);
                                    EventBus.$emit("vendorWoCount", data.content.vendorWoEstimateCnt);

                                }
                            }


                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR, false, 'customer-estimate-list');
                    }
                });
            },

            workOrderEstimateDelete() {

                var self = this;
                self.$swal({
                    title: 'Are you sure that you want to delete this Customer Estimate?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                      self.loading = true;
                      $("#deleteWorkOrderEstimateBtn").val("Deleting ...");
                      self.action="delete";
                      self.loadList();

                    } else {
                      console.log("no");
                    }
                });
                // if (confirm('Are you sure that you want to delete this Customer Estimate? ')) {

                //

                // }

            },

            createWorkOrder() {

                var self = this;

                if ( this.$refs['listEstimateWorkOrderTable'].selectedRows.length != 1 ) {
                    self.$swal('',"Kindly choose only one estimate.",'info');
                    return;
                }

                if ( this.$refs['listEstimateWorkOrderTable'].selectedRows[0].work_order_no != '-' ) {
                    self.$swal('',"Work Order has already been created.",'info');
                    return;
                }

                if (confirm('Are you sure that you want to create work order from the estimate? ')) {
                    this.$router.push({ name: 'WorkOrderCreate', params:{estimateWoId: this.$refs['listEstimateWorkOrderTable'].selectedRows[0].id, redirectFrom: 'CustomerEstimateList'}})
                }

            },

            sendWorkOrderEstimate() {
                var self = this;

                if (confirm('Are you sure that you want to send this estimate? ')) {
                    self.loading = true;
                    $("#sendWorkOrderEstimateBtn").val("Sending ...");
                    self.action="sendEstimate";
                    self.loadList();
                }

            },
            approveRejectEstimate() {
                var self = this;
                console.log(this.$refs['listEstimateWorkOrderTable'].selectedRows[0]);

                if ( this.$refs['listEstimateWorkOrderTable'].selectedRows.length != 1 ) {
                    self.$swal('',"Kindly choose only one estimate.",'info');
                    return;
                }

                if ( this.$refs['listEstimateWorkOrderTable'].selectedRows[0].status == 'Open' ) {
                    self.$swal('',"Estimate with status open cannot be approved or rejected.",'info');
                    return;
                }

                if ( this.$refs['listEstimateWorkOrderTable'].selectedRows[0].status == 'Approved' ) {
                    self.$swal('',"Estimate has already been approved.",'info');
                    return;
                }

                if ( this.$refs['listEstimateWorkOrderTable'].selectedRows[0].status == 'Rejected' ) {
                    self.$swal('',"Estimate has already been rejected.",'info');
                    return;
                }
                self.reason = "";
                $("#approve-reject-modal").modal("show");

            },
            sendApproveOrRejectEstimate(action){
                var self = this;
                var error = false;

                self.reason_error_msg = "";

                if(self.reason == "" || !self.reason){
                    self.reason_error_msg = "Reason Required.";
                    error = true;
                }

                if(!error){

                    var estimateId = this.$refs['listEstimateWorkOrderTable'].selectedRows[0].id;

                    var fields = {
                        id:estimateId,
                        reason:self.reason,
                        flag:action,
                    }

                    $.ajax({
                        url: process.env.ROOT_API + "/customer-estimate/approve-reject",
                        type: "POST",
                        data: fields,
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            self.reason = "";
                            $("#approve-reject-modal").modal("hide");
                            if (data.code == '200') {
                                var message = data.message;
                                self.loadList();
                                self.$swal('',message,'success');

                            }else{

                                self.$swal('','Oops please try again !!','error');

                            }

                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            $("#approve-reject-modal").modal("hide");
                            self.generateStatusCodeMessage(jqXHR, true, 'customer-estimate-approve-reject');
                        }
                    });

                }

            },
            exportCheck: function() {
                var count = 0;
                var actionFlag = "";
                var data = this.$refs['listEstimateWorkOrderTable'].selectedRows;
                count = data.length;
                if(this.serverParams.selectedAll == true){
                    actionFlag = "";
                }else if(count != 0 && count <= 100){
                    actionFlag = "export";
                }
                this.exportReports(actionFlag);
            },
        }
    };
</script>





// WEBPACK FOOTER //
// src/components/CustomerEstimateList.vue